// extracted by mini-css-extract-plugin
export default {"container":"SourceButton_container__lDRvV","collapselikebutton":"SourceButton_collapselikebutton__fW4Xh"};